import * as yup from 'yup';
import { UrlType } from 'pages/media-library/interface';
import { isYouTubeUrl } from 'utils/youtube-utils';
import { FIELD_LIMITS } from 'utils/character-count-utils';

const addContentsModalFormValidation = yup.object().shape({
  contentUrl: yup.string().trim().required(' Media  is a required field').test({
    name: 'test-url',
    test(value) {
      const { urlType } = this.parent;

      if (!value?.startsWith('https://') && !value?.startsWith('http://')) {
        return this.createError({ path: 'contentUrl', message: 'Please enter a valid URL that starts with https:// or http://' });
      }

      if (urlType === UrlType.YOUTUBE_LINK) {
        if (!isYouTubeUrl(value)) {
          return this.createError({
            path: 'contentUrl',
            message: 'Please enter a valid YouTube URL (e.g., https://www.youtube.com/watch?v=VIDEO_ID or https://youtu.be/VIDEO_ID)',
          });
        }
        return true;
      }

      if (urlType === UrlType.PUBLIC_URL || !urlType) {
        if (!value?.startsWith('https://')) {
          return this.createError({ path: 'contentUrl', message: 'Please enter a secured file URL that starts with https://' });
        }
        if (value?.startsWith('https://youtu') || value?.startsWith('https://vimeo')) {
          return this.createError({
            path: 'contentUrl',
            message: 'This file URL is not supported. Only URLs with file types .jpg, .jpeg, .png, .gif, .mp4, .flv, .mkv, .webm, .mov, .wmv, .pdf, .ppt, .pptx, .xls, .xlsx, .csv attached are allowed',
          });
        }
      }

      return true;
    },
  }),
  title: yup.string().trim().required('Title  is a required field'),
  description: yup.string().trim(),
  fileType: yup.string().trim().required('Media is a required field'),
  fileName: yup.string().trim().required('Media is a required field'),
  path: yup.string().trim().required('Path is a required field'),
  urlType: yup.string().oneOf(Object.values(UrlType)).optional(),
});

export const addContentFieldConfigs = {
  title: FIELD_LIMITS.TITLE,
  description: FIELD_LIMITS.DESCRIPTION,
};

export default addContentsModalFormValidation;
